module.exports = __webpack_public_path__ + "img/entry_medias_step.c4d04cb5.png";